import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { TweenMax, Linear } from 'gsap'
import '../styles/site-loader.scss'
import { onLoaderHidden } from '../actions'

class Loader extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  state = { hidden: false }

  componentDidMount () {
    this.animate()

    if (!this.props.isLoading) {
      this.hide()
    }
  }

  componentWillReceiveProps (next) {
    if (next.isLoading !== this.props.isLoading) {
      this.hide()
    }
  }

  animate = () => {
    TweenMax.to('.site-loader__svg-wave', 1.8, { x: -265, repeat: -1, ease: Linear.easeNone })
  }

  hide = () => {
    this.setState({ hidden: true })
  }

  onHideComplete = () => {
    const { dispatch } = this.props
    dispatch(onLoaderHidden())
  }

  render () {
    const { hidden } = this.state
    return (
      <div onTransitionEnd={this.onHideComplete} className={hidden ? 'site-loader hidden' : 'site-loader'}>
        <svg className="site-loader__svg" viewBox="0 0 265 33.2">
          <defs>
            <path id="path" d="M265.3 0c-12.8 0-19.3 7.4-25.1 14 -5.3 6.1-9.9 11.3-19.2 11.3 -9.3 0-13.9-5.3-19.2-11.3C196.1 7.4 189.6 0 176.8 0c-12.8 0-19.3 7.4-25.1 14 -5.3 6.1-9.9 11.3-19.2 11.3s-13.9-5.3-19.2-11.3C107.6 7.4 101.1 0 88.2 0S68.9 7.4 63.2 14c-5.3 6.1-9.9 11.3-19.2 11.3 -9.3 0-13.9-5.3-19.2-11.3C19.1 7.5 12.7 0.1 0 0v7.8c9.1 0.1 13.7 5.3 18.9 11.3 5.7 6.6 12.2 14 25.1 14 12.8 0 19.3-7.4 25.1-14 5.3-6.1 9.9-11.3 19.2-11.3 9.3 0 13.9 5.3 19.2 11.3 5.7 6.6 12.2 14 25.1 14 12.8 0 19.3-7.4 25.1-14 5.3-6.1 9.9-11.3 19.2-11.3 9.3 0 13.9 5.3 19.2 11.3 5.7 6.6 12.2 14 25.1 14s19.3-7.4 25.1-14c5.3-6.1 9.9-11.3 19.2-11.3V0z" />
          </defs>
          <use className="site-loader__svg-wave" xlinkHref="#path" x="0" />
          <use className="site-loader__svg-wave" xlinkHref="#path" x="265" />
        </svg>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { isLoading } = state.slides
  return { isLoading }
}
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Loader)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Loader.js